import React, { forwardRef, memo } from "react";
import { Loader2 } from "lucide-react";

import { cn } from "~/services/shadcn";

type LoadingProps = {
  children?: React.ReactNode;
  className?: string;
};

export const Loading = memo(
  forwardRef<HTMLDivElement, LoadingProps>(function Loading({ children, className }, ref) {
    return (
      <div className={cn("flex items-center space-x-2", className)} ref={ref}>
        <Loader2 className="h-5 w-5 animate-spin text-white/80 duration-500" />

        <div className="text-lg font-semibold">{children}</div>
      </div>
    );
  }),
);
